"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SubclassExpectedError extends Error {
}
exports.SubclassExpectedError = SubclassExpectedError;



//////////////////
// WEBPACK FOOTER
// ./src/pathfinding/errors.ts
// module id = 10
// module chunks = 0